module.exports = __webpack_public_path__ + "static/media/ramen-dark.ecbe7b60.gif";